module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAqElEQVRYhe3Yyw2DMBRE0XEqoCAXkzTgKB2kBOIGoBgXlA6MlGUke/yRQaC5SwTvHVmwAYpkeg4oOrsAuP9dXo0Pj9aZzaAEphuVBJGFvSXBt8zgUZjs7BzokHKgdeDekbMvXvFnH52NPUdhfCjadaqX+pAEYgnEEoglEEsglkAsgVgCsQRi7QX6jgDNbZZfn9Ibq/5+RGffAJ4AporHZuPDq2aPSgZgA/TKHEl+bXcgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_delete@2x.png
// module id = 730
// module chunks = 0